import MultiForm from './MultiForm';
import MultiFormGroup from './MultiFormGroup';
import MultiFormInput from './MultiFormInput';
import MultiFormSection from './MultiFormSection';
import MultiFormSelect from './MultiFormSelect';

export default Object.assign(MultiForm, {
    Group: MultiFormGroup,
    Input: MultiFormInput,
    Section: MultiFormSection,
    Select: MultiFormSelect,
});
